export default {
	install() {
		let body = document.getElementsByTagName("body");
		body = body.item(0);

		const onMouseDown = () => {
			body.classList.remove("vg-is-tabbing");
			body.classList.add("vg-is-not-tabbing");

			window.removeEventListener("mousedown", onMouseDown);
			window.addEventListener("keydown", onKeyDown);
		};

		const onKeyDown = (e) => {
			// Tab key
			if (e.keyCode === 9) {
				body.classList.remove("vg-is-not-tabbing");
				body.classList.add("vg-is-tabbing");

				window.removeEventListener("keydown", onKeyDown);
				window.addEventListener("mousedown", onMouseDown);
			}
		};

		if (body) {
			window.addEventListener("keydown", onKeyDown);
			window.addEventListener("mousedown", onMouseDown);
		}
	}
};
